/**
 * App Ready Boot File
 *
 * Splash dismissal moved to router/index.ts (one-shot router.afterEach),
 * because Quasar boot files run BEFORE app.mount() — firing setInitialized
 * here would dismiss the splash before any page component is on screen,
 * leaving a blank view during the fade. The router hook is the earliest
 * place where the destination page is guaranteed to be mounted.
 *
 * Kept as a no-op for now so the boot order in quasar.config.ts doesn't
 * need editing; safe to delete entirely if you want to slim the boot list.
 */

import { defineBoot } from '#q-app';

export default defineBoot(() => {
  // intentionally empty — see header comment
});
